import { Button } from '@skin-seoul/design-system';

interface ToggleIconProps {
  isCollapsed: boolean;
}

export const ToggleIcon = ({ isCollapsed }: ToggleIconProps) => {
  return (
    <Button
      w="21px"
      h="21px"
      bg="white"
      borderRadius="100px"
      border="none"
      cursor="pointer"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      p="0"
      transition="all 0.2s"
      _hover={{ bg: 'white' }}
      aria-label={isCollapsed ? 'Expand' : 'Collapse'}
      css={{
        svg: {
          transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
        },
      }}
    >
      {!isCollapsed && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 20" fill="none">
          <path d="M4.16602 10H15.8327" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      )}
      {isCollapsed && (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16699 10H15.8337" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M10 4.16663V15.8333" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      )}
    </Button>
  );
};

export default ToggleIcon;
